import { useCallback, useRef, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

type CopyToClipboardAreaProps = {
  className?: string;
  timeoutMS?: number;
  content: string;
  anchor: (success: boolean) => React.ReactNode;
};

export const CopyToClipboardArea = ({ className, timeoutMS = 1000, content, anchor }: CopyToClipboardAreaProps) => {
  const [success, setSuccess] = useState(false);

  const timeout = useRef<NodeJS.Timeout | null>(null);

  const copyToClipboard = useCallback(() => {
    setSuccess(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      setSuccess(false);
    }, timeoutMS);
  }, [timeoutMS]);

  return (
    <CopyToClipboard text={content} onCopy={copyToClipboard}>
      {anchor(success)}
    </CopyToClipboard>
  );
};
